/**
 * Pure utility functions for AG Grid field ID transformations.
 *
 * These functions handle the conversion between column names and their field IDs.
 * Reference columns (type: 'reference') use a trailing '*' suffix to distinguish
 * them from their source ID columns.
 *
 * Example:
 * - Column name: "Condition"
 * - Field ID: "Condition*"
 * - Referenced column: "ConditionID"
 *
 * This file has zero dependencies to ensure it remains a leaf node in the dependency graph.
 */

/**
 * Converts a column name to a reference field ID by appending '*'.
 *
 * @param name - The column name
 * @returns The field ID with '*' suffix
 *
 * @example
 * nameToReferenceKey('Condition') // Returns: 'Condition*'
 */
export function nameToReferenceKey(name: string): string {
  return `${name}*`;
}

/**
 * Converts a reference field ID back to a column name by removing the trailing '*'.
 *
 * @param key - The field ID (may or may not have '*' suffix)
 * @returns The column name without '*' suffix
 *
 * @example
 * referenceKeyToName('Condition*') // Returns: 'Condition'
 * referenceKeyToName('Condition')  // Returns: 'Condition'
 */
export function referenceKeyToName(key: string): string {
  return key?.replace(/\*$/, '');
}
